import './main.css';
import ProductRoutes from './Products/ProductRoutes';
import Bonuses from '../../Modules/DepositBonus/Bonuses';


function Main() {
    return (
        <>
            <main className='main_page'>
                <Bonuses />
                <ProductRoutes />
            </main>
        </>
    );
}

export default Main